<template>
  <sdPageHeader title="Pembinaan Person Grade"> </sdPageHeader>
  <Main>
    <sdCards headless>
      <div class="header-actions">
        <div class="search-section">
          <a-input-search
            v-model="searchQuery"
            placeholder="Cari Sesuatu..."
            style="width: 250px"
            @search="handleSearch"
          />
        </div>
        <a-button v-if="has_inisialisasi" type="primary" @click="showModal">
          Buat Pengajuan
        </a-button>

        <!-- Informed Consent Modal -->
        <a-modal
          v-model:visible="modalVisible"
          title="Kebijakan Privasi"
          :footer="null"
          width="900px"
          :bodyStyle="{ padding: 0 }"
          @cancel="handleCancel"
          class="consent-modal"
        >
          <div class="modal-content-wrapper">
            <div v-if="loadingPolicy" style="padding: 24px; text-align: center;">
              <a-spin tip="Memuat kebijakan privasi..."></a-spin>
            </div>
            <div
              v-else
              class="consent-content"
              ref="policyContent"
              @scroll="handleScroll"
              v-html="privacyPolicyContent"
            ></div>

            <div class="modal-fixed-footer">
              <div class="consent-checkbox">
                <a-checkbox v-model:checked="consentChecked" :disabled="!hasReachedBottom">
                  Saya telah membaca dan menyetujui Kebijakan Privasi
                </a-checkbox>
              </div>
              <div class="divider"></div>

              <div class="modal-footer">
                <div style="text-align: right;">
                  <a-space>
                    <a-button @click="handleCancel" danger>
                      Batal
                    </a-button>
                    <a-button
                      type="primary"
                      :disabled="!consentChecked"
                      @click="handleContinue"
                      :loading="isSubmitting"
                    >
                      Lanjut
                    </a-button>
                  </a-space>
                </div>
              </div>
            </div>
          </div>
        </a-modal>
      </div>

      <a-table
        :columns="columns"
        :data-source="tableData"
        :loading="loading"
        :pagination="{
          total: pagination.total,
          current: pagination.current,
          pageSize: pagination.pageSize,
          showSizeChanger: pagination.showSizeChanger,
          pageSizeOptions: pagination.pageSizeOptions || ['10', '20', '50'],
          showTotal: pagination.showTotal,
        }"
        @change="handleTableChange"
      >
        <template #status="{ text }">
          <a-tag :color="getStatusColor(text)">
            {{ text }}
          </a-tag>
        </template>

        <template #action="{ record }">
          <a-button type="link" @click="handleViewDetails(record)">
            <eye-outlined />
          </a-button>
        </template>
      </a-table>
    </sdCards>
  </Main>

  <!-- No Data Modal -->
  <a-modal v-model:visible="noDataModalVisible" title="Informasi" @ok="noDataModalVisible = false">
    <p>Pegawai Belum Memenuhi Syarat untuk Pembinaan PeG</p>
    <template #footer>
      <a-button type="primary" @click="noDataModalVisible = false">
        OK
      </a-button>
    </template>
  </a-modal>
</template>

<script>
import { Main } from '../styled';
import { EyeOutlined } from '@ant-design/icons-vue';
import assessmentApi from '@/api/assessment';
import { getItem } from '@/utility/localStorageControl';
import axios from 'axios';
import { handleSessionExpired } from '@/utility/utility';

const ViewPage = {
  name: 'Assessment',
  components: {
    Main,
    EyeOutlined,
  },
  data() {
    return {
      privacyPolicyContent: '',
      informedConsentId: null,
      ipAddress: null,
      loadingPolicy: false,
      consentAccepted: false,
      modalVisible: false,
      consentChecked: false,
      hasReachedBottom: false,
      isSubmitting: false,
      canCreateSubmission: false,
      has_inisialisasi: false,
      pengajuanId: null,
      searchQuery: '',
      formState: {
        search: '',
      },
      columns: [
        {
          title: 'No',
          dataIndex: 'no',
          key: 'no',
          width: 70,
        },
        {
          title: 'NIP',
          dataIndex: 'nip',
          key: 'nip',
        },
        {
          title: 'Nama Pegawai',
          dataIndex: 'namaPegawai',
          key: 'namaPegawai',
        },
        {
          title: 'PeG',
          dataIndex: 'peg',
          key: 'peg',
          width: 80,
        },
        {
          title: 'Jabatan',
          dataIndex: 'jabatan',
          key: 'jabatan',
        },
        {
          title: 'PoG Jabatan Existing',
          dataIndex: 'pog',
          key: 'pog',
        },
        {
          title: 'Proyeksi Jabatan',
          dataIndex: 'proyeksiJabatan',
          key: 'proyeksiJabatan',
        },
        // {
        //   title: 'Personal Area',
        //   dataIndex: 'personalArea',
        //   key: 'personalArea',
        // },
        {
          title: 'Status',
          dataIndex: 'status',
          key: 'status',
          slots: { customRender: 'status' },
        },
        {
          title: 'Aksi',
          key: 'action',
          width: 100,
          slots: { customRender: 'action' },
        },
      ],
      loading: false,
      tableData: [],
      pagination: {
        total: 1,
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50'],
        showTotal: (total, range) => `Menampilkan ${range[0]}-${range[1]} dari ${total} Data`,
        onChange: () => {}, // Empty function to be filled by handleTableChange
        onShowSizeChange: () => {}, // Empty function to be filled by handleTableChange
      },
      noDataModalVisible: false,
    };
  },
  async created() {
    try {
      // Get IP address
      this.ipAddress = await this.getIpAddress();
    } catch (error) {
      console.error('Error in getIpAddress:', error);
      this.ipAddress = '127.0.0.1'; // Fallback
    }

    // Get permissions from localStorage
    const permissions = getItem('permissions') || [];

    // Check if user has approval permissions
    const hasApprove1Permission = permissions.includes('approve 1 assessment');
    const hasApprove2Permission = permissions.includes('approve 2 assessment');
    const hasApproveHcPermission = permissions.includes('approve hc assessment');

    if (hasApprove1Permission || hasApprove2Permission || hasApproveHcPermission) {
      // Redirect to approval page if user has approval permissions
      this.$router.push('/assessment/approval');
    } else {
      // Only fetch data and check submission status if not an approver
      this.fetchTableData();
      this.checkSubmissionStatus();
    }
  },
  methods: {
    getIpAddress() {
      return new Promise(resolve => {
        axios
          .get('https://api.ipify.org?format=json')
          .then(response => {
            resolve(response.data.ip);
          })
          .catch(error => {
            console.error('Error getting IP address:', error);
            resolve('127.0.0.1'); // Fallback to localhost if API fails
          });
      });
    },
    checkSubmissionStatus() {
      // Show loading state
      this.loading = true;

      // Get access token from localStorage
      const accessToken = getItem('access_token');

      // Set headers with the token
      const headers = {};
      if (accessToken) {
        headers['Authorization'] = `Bearer ${accessToken}`;
      }

      // Fetch status from the API
      // const apiUrl = process.env.VUE_APP_API_ASS || '';
      assessmentApi
        .get('check-status', { headers })
        .then(response => {
          if (response.data && response.data.data) {
            // Store the data in global variables
            this.has_inisialisasi = response.data.data.has_inisialisasi;
            this.pengajuanId = response.data.data.id_pengajuan;

            // Update button visibility based on has_inisialisasi flag
            this.canCreateSubmission = this.has_inisialisasi;
            console.log('Submission status:', response.data.data);
          }
        })
        .catch(error => {
          console.error('Error checking submission status:', error);
          // Default to showing the button if there's an error
          this.canCreateSubmission = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    fetchTableData() {
      // Show loading state
      this.loading = true;

      // Get access token from localStorage
      const accessToken = getItem('access_token');

      // Get profile data from localStorage
      // const profileData = getItem('profile_plnbb') || {};
      // const requestId = profileData.id || '';
      // const postData = {
      //   id: parseInt(requestId),
      // };

      // Set headers with the token
      const headers = {};
      if (accessToken) {
        headers['Authorization'] = `Bearer ${accessToken}`;
      }

      // Prepare query parameters for pagination
      const params = {
        page: this.pagination.current,
        per_page: this.pagination.pageSize,
      };

      // Add search query if present - specifically for employee name
      if (this.searchQuery) {
        params.jabatan = this.searchQuery.toUpperCase();
      }

      // Fetch data from the API with request ID from profile
      assessmentApi
        .get(`my-pengajuan?with=proyeksiJabatan,userAssessment`, {
          headers,
          params,
        })
        .then(response => {
          if (response.data && response.data.data && response.data.data.data) {
            const apiData = response.data.data.data;

            if (apiData.length === 0) {
              this.noDataModalVisible = true;
              return;
            }

            // Map API data to table format
            this.tableData = apiData.map((item, index) => {
              const proyeksi = item.proyeksi_jabatan || {};
              const userAssessment = item.user_assessment || {};
              return {
                key: item.id.toString(),
                no: index + 1,
                nip: item.nip || '',
                namaPegawai: userAssessment.name || '',
                peg: item.peg || '',
                jabatan: item.jabatan || '',
                // proyeksiJabatan: proyeksi.jabatan || '',
                proyeksiJabatan: (proyeksi.pog ? proyeksi.pog + ' - ' : '') + (proyeksi.jabatan || ''),
                // pog: proyeksi.pog ? proyeksi.pog.toString() : '',
                pog: item.peg || '',
                // personalArea: userAssessment.personal_area, // Not provided in API response
                status: this.formatStatus(item.status),
                record: item, // Store the full record for reference
              };
            });

            // Update pagination
            const paginationInfo = response.data.data;
            this.pagination = {
              ...this.pagination,
              total: paginationInfo.total || 0,
              current: paginationInfo.current_page || 1,
              pageSize: paginationInfo.per_page || 10,
              // Preserve the callback functions
              onChange: page => {
                this.pagination.current = page;
                this.fetchTableData();
              },
              onShowSizeChange: (current, size) => {
                this.pagination.current = current;
                this.pagination.pageSize = size;
                this.fetchTableData();
              },
            };
          }
        })
        .catch(error => {
          console.error('Error fetching table data:', error);
          this.$message.error('Gagal memuat data pengajuan');
          if (error.response && error.response.status === 401) {
            handleSessionExpired();
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    async checkSubmissionPeriod() {
      try {
        const token = getItem('access_token');
        const response = await assessmentApi.get('/check-submission-period', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        return response.data.is_submission_period;
      } catch (error) {
        if (error.response?.status === 401) {
          this.$message.error('Sesi anda telah berakhir, silahkan login kembali');
        } else {
          this.$message.error('Gagal memeriksa periode pengajuan');
        }
        return false;
      }
    },

    formatStatus(status) {
      // Format the status for display
      switch (status) {
        case 'inisialisasi':
          return 'Inisiasi Pengajuan';
        case 'disetujui':
          return 'Disetujui';
        case 'ditolak':
          return 'Ditinjau Ulang';
        case 'menunggu_approval_atasan':
          return 'Menunggu Approval Atasan';
        case 'menunggu_approval_bod1':
          return 'Menunggu Approval BOD-1';
        case 'menunggu_approval_hc':
          return 'Menunggu Approval HC';
        case 'disetujui_hc':
          return 'Disetujui Oleh HC';
        case 'ditolak_hc':
          return 'Ditinjau Ulang Oleh HC';
        default:
          return status || 'Unknown';
      }
    },
    handleSearch(value) {
      console.log('Searching for nama pegawai:', value);
      // Update search query to filter by employee name
      this.searchQuery = value;
      // Reset pagination to first page when searching
      this.pagination.current = 1;
      // Fetch data with the search parameter
      this.fetchTableData();
    },
    async showModal() {
      const isSubmissionPeriod = await this.checkSubmissionPeriod();
      if (!isSubmissionPeriod) {
        this.$message.warning('Maaf, saat ini belum masa pengajuan');
        return;
      }

      // Check if user has already accepted the consent
      const hasAcceptedConsent = await this.cekConsent();

      if (hasAcceptedConsent) {
        // User has already accepted consent, proceed directly to pengajuan
        this.$message.success('Anda telah menyetujui kebijakan privasi sebelumnya');
        this.$router.push({ name: 'pengajuan', params: { pengajuanId: this.pengajuanId } });
      } else {
        // User has not accepted consent, show the modal
        this.modalVisible = true;
        this.fetchInformedConsent();
      }
    },

    async fetchInformedConsent() {
      try {
        this.loadingPolicy = true;
        const response = await axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/informed-consent`);
        this.informedConsentId = response.data?.data?.id; // Get the informed consent ID
        this.privacyPolicyContent = response.data?.data?.content || 'Kebijakan privasi tidak tersedia.';
      } catch (error) {
        console.error('Error fetching informed consent:', error);
        this.$message.error('Terjadi kesalahan saat mengambil kebijakan privasi');
        this.privacyPolicyContent = 'Terjadi kesalahan saat mengambil kebijakan privasi.';
      } finally {
        this.loadingPolicy = false;
      }
    },

    handleCancel() {
      this.modalVisible = false;
      this.consentChecked = false;
    },

    handleContinue() {
      try {
        this.isSubmitting = true;
        // Call your API here to create the submission
        this.handleCreateSubmission();
        this.modalVisible = false;
        this.consentChecked = false;
        this.$router.push({ name: 'pengajuan', params: { pengajuanId: this.pengajuanId } });
      } catch (error) {
        console.error('Error creating submission:', error);
      } finally {
        this.isSubmitting = false;
      }
    },

    async cekConsent() {
      try {
        const headers = {
          Authorization: `Bearer ${getItem('access_token')}`,
        };

        const response = await assessmentApi.get('/check-user-informed-consent', { headers });

        // The API now returns a simple JSON response: {"accepted": true/false}
        if (response.data && Object.hasOwn(response.data, 'accepted')) {
          // Set the consent status based on the response
          this.consentAccepted = response.data.accepted;
          return response.data.accepted;
        } else {
          // If the response doesn't have the expected format, assume not accepted
          console.warn('Unexpected response format from consent check API:', response.data);
          this.consentAccepted = false;
          return false;
        }
      } catch (error) {
        console.error('Error checking consent status:', error);
        this.consentAccepted = false;
        return false;
      }
    },

    handleCreateSubmission() {
      // Implement create submission logic here
      const headers = {
        Authorization: `Bearer ${getItem('access_token')}`,
      };
      const postData = {
        user_id: this.userId,
        informed_consent_id: this.informedConsentId,
        ip_address: this.ipAddress,
      };
      assessmentApi
        .post('/accept-consent', postData, { headers })
        .then(() => {
          this.$message.success('Anda telah menyetujui kebijakan privasi');
        })
        .catch(error => {
          console.error('Error creating submission:', error);
          this.$message.error('Gagal menyetujui kebijakan privasi');
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },
    handleTableChange(pagination, filters, sorter) {
      console.log('Table params changed:', { pagination, filters, sorter });
      // Update pagination state
      this.pagination = {
        ...this.pagination,
        current: pagination.current,
        pageSize: pagination.pageSize,
        // Update the callback functions
        onChange: page => {
          this.pagination.current = page;
          this.fetchTableData();
        },
        onShowSizeChange: (current, size) => {
          this.pagination.current = current;
          this.pagination.pageSize = size;
          this.fetchTableData();
        },
      };

      // Fetch data with updated pagination
      this.fetchTableData();
    },
    handleViewDetails(record) {
      // Redirect to monitoring view with the record ID
      console.log('Viewing details for:', record);
      this.$router.push({ name: 'monitoring', params: { id: record.key } });
    },
    getStatusColor(status) {
      // Customize the color based on different statuses
      switch (status) {
        case 'Inisiasi Pengajuan':
          return 'blue';
        case 'Disetujui':
          return 'green';
        case 'Ditinjau Ulang':
          return 'red';
        case 'Menunggu Approval Atasan':
          return 'orange';
        case 'Menunggu Approval BOD-1':
          return 'orange';
        case 'Menunggu Approval HC':
          return 'orange';
        case 'Disetujui Oleh HC':
          return 'green';
        case 'Ditinjau Ulang Oleh HC':
          return 'red';
        default:
          return 'default';
      }
    },
    handleScroll(e) {
      const element = e.target;
      const bottomReached = Math.abs(element.scrollHeight - element.scrollTop - element.clientHeight) < 1;
      if (bottomReached) {
        this.hasReachedBottom = true;
      }
    },
  },
};

export default ViewPage;
</script>

<style scoped>
.modal-content-wrapper {
  display: flex;
  flex-direction: column;
  height: 70vh;
}

.consent-content {
  flex: 1;
  overflow-y: auto;
  padding: 24px;
  font-size: 14px;
  line-height: 1.6;
  text-align: justify;
}

.modal-fixed-footer {
  background: #fff;
  border-top: 1px solid #f0f0f0;
  padding: 24px;
  border-radius: 0 0 8px 8px;
}

.consent-content h4 {
  font-size: 16px;
  font-weight: bold;
  margin: 24px 0 16px;
}

.consent-content p {
  margin-bottom: 16px;
}

.consent-content ol {
  margin-left: 20px;
  margin-bottom: 16px;
}

.consent-content li {
  margin-bottom: 8px;
}

.consent-checkbox {
  margin-bottom: 24px;
}

.divider {
  margin-bottom: 24px;
}

:deep(.ant-modal-body) {
  padding: 0;
  border-radius: 0 0 8px 8px;
}

:deep(.ant-modal-header) {
  margin-bottom: 0;
}

:deep(.ant-modal-content) {
  border-radius: 8px;
}

.header-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.search-section {
  display: flex;
  gap: 16px;
  align-items: center;
}

.ant-table {
  margin-top: 20px;
}
</style>
